import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10 7.01888V6.13925M10 14.9355V15.8152M12.0834 8.47721C11.7031 7.95137 10.814 7.45869 10 7.45869C9.04811 7.45869 7.80097 7.86596 7.80097 9.02248C7.80097 11.527 12.1991 10.473 12.1991 12.8648C12.1991 14.0126 10.9669 14.4957 10 14.4957C9.18607 14.4957 8.1812 14.0031 7.80097 13.4772M17.9167 10.9772C17.9167 15.3495 14.3723 18.8939 10 18.8939C5.62779 18.8939 2.08337 15.3495 2.08337 10.9772C2.08337 6.60496 5.62779 3.06055 10 3.06055C14.3723 3.06055 17.9167 6.60496 17.9167 10.9772Z",
      stroke: "currentColor",
      "stroke-linecap": "square"
    }, null, -1)
  ])))
}
export default { render: render }